import { Box, Flex, Stack } from '@chakra-ui/react'
import { range } from 'lodash'
import { FC, ReactNode } from 'react'
import { BsStarFill } from 'react-icons/bs'

import { Body1, H6 } from '../typography'

const reviewsArr = [
  {
    review: 'Depois de uma semana fazendo os exercícios que me passaram fiquei com desempenho insano na hora H',
    name: 'V.C.'
  },
  {
    review: 'Tive bons resultados, principalmente por desenvolver com minha esposa um olhar mais consciente',
    name: 'M.F.'
  },
  {
    review: 'Muito feliz pelo comprometimento da equipe Omens na qualidade do atendimento com o cliente.',
    name: 'E.S.'
  }
]

/** `footer`: a line under the stars (GEO home: Reclame Aqui, PRD 2.7). */
const ReviewsBriefSection: FC<{ footer?: ReactNode }> = ({ footer }) => {
  return (
    <Stack align="center" bg="alabaster" py={{ base: '28px', lg: '80px' }} px={6} gap="44px">
      <Flex
        maxW={{ base: '400px', lg: '1280px' }}
        gap="64px"
        direction={{ base: 'column', lg: 'row' }}
        textAlign={{ base: 'center', lg: 'left' }}
      >
        {reviewsArr.map((item, index) => (
          <ReviewCard key={index} {...item} />
        ))}
      </Flex>
      <Flex mx="auto" maxW="1120" alignItems="center" gap={3} direction={{ base: 'column', lg: 'row' }}>
        <Body1>Aprovado por mais de 35 mil brasileiros</Body1>
        <Flex gap="2px">
          {range(5).map((index) => (
            <BsStarFill key={index} />
          ))}
        </Flex>
      </Flex>
      {footer}
    </Stack>
  )
}

export default ReviewsBriefSection

interface ReviewCardProps {
  review: string
  name: string
}
const ReviewCard: FC<ReviewCardProps> = ({ review, name }) => (
  <Box>
    <H6>&ldquo;{review}&rdquo;</H6>
    <H6>— {name}</H6>
  </Box>
)
